// import React, { useEffect, useState } from "react";
// import { Tooltip, Modal, Box, Typography, CircularProgress } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link } from "react-router-dom";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import patientService from "../../../Services/patientService";
// import toast from 'react-hot-toast';
// import doctorService from "../../../Services/doctorService";
// import DoctorDetailsModal from "./DoctorDetailsModal";


// const Doctors = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const getDoctors = async () => {
//       try {
//         setLoading(true);
//         const response = await doctorService.fetchAllDoctors();
//         console.log(response);
//         setPatients(response.doctors);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error('Error fetching doctors');
//       }
//     };
//     getDoctors();
//   }, []);

//   useEffect(() => {
//     const filteredResult = patients?.filter(
//       (item) =>
//         item?.name?.toLowerCase().includes(searchData.toLowerCase())
//     ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, patients]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handleViewClick = (doctor) => {
//     setSelectedDoctor(doctor);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedDoctor(null);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">Doctors</h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">{filteredData?.length || 0} records found</h1>
        
//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           <Link to='AddEditDoctor'>
//             <button className="bg-[#232233] h-[2rem] px-4 rounded-md text-white font-[600] text-[14px]">
//               + New Doctor
//             </button>
//           </Link>
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-[100%]">
//             <thead>
//               <tr className="text-[#101418] capitalize leading-normal text-sm">
//               <th className="py-[1%] w-[10%] text-gray-700 text-left pl-4">Sr No.</th>
//               <th className="py-[1%] w-[20%] text-gray-700 text-left">Name</th>
//                 <th className="py-[1%] w-[20%] text-gray-700 text-left pl-4">Specialization</th>
//                 <th className="py-[1%] w-[10%] text-gray-700 text-left">Contact Number</th>
//                 <th className="py-[1%] w-[10%] text-gray-700 text-center">CNIC</th>
//                 <th className="py-[1%] w-[20%] text-gray-700 text-center">Qualification</th>
//                 <th className="py-[1%] w-[10%] text-gray-700 text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient) => (
//                 <tr key={patient?.patient_id} className="bg-white text-gray-600 text-xs font-light border-t-[1px] border-gray-200">
//                   <td className="w-[10%] text-left">
//                     <p className="font-[600] text-gray-600 pl-4">{patient?.id}</p>
//                   </td>
//                   <td className="w-[20%] text-left">
//                     <p className="font-[600] text-gray-600 text-left">{patient?.name}</p>
//                   </td>
//                   <td className="py-4 w-[20%] text-left pl-4">
//                     <p className="font-[600] text-gray-600">{patient?.specialization}</p>
//                   </td>
//                   <td className="w-[10%] text-left">
//                     <p className="font-[600] text-gray-600">{patient?.phone_no}</p>
//                   </td>
//                   <td className="py-4 px-2 w-[10%] text-center">
//                     <span className="font-[400]">{patient?.cnic}</span>
//                   </td>
//                   <td className="py-4 px-2 w-[20%] text-center">
//                     <span className="font-[400]">{patient?.qualification}</span>
//                   </td>
//                   {/* <td className="py-4 w-[10%] text-center">
//                     <Link to={`/patient/patients/${patient.id}`}>
//                       <button className="text-[13px] font-[500] text-blue-500">View</button>
//                     </Link>
//                   </td> */}
//                    <td className="py-4 w-[10%] text-center">
//                     <button
//                       onClick={() => handleViewClick(patient)}
//                       className="text-[13px] font-[500] text-blue-500"
//                     >
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           data={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>

//       <DoctorDetailsModal
//         isOpen={isModalOpen}
//         onClose={handleCloseModal}
//         doctorDetails={selectedDoctor}
//       />
//     </div>
//   );
// };

// export default Doctors;




import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import doctorService from "../../../Services/doctorService";
import DoctorDetailsModal from "./DoctorDetailsModal";

const Doctors = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const getDoctors = async () => {
      try {
        setLoading(true);
        const response = await doctorService.fetchAllDoctors();
        setPatients(response.doctors);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching doctors");
      }
    };
    getDoctors();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) =>
        item?.name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];

    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, patients]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  const handleViewClick = (doctor) => {
    setSelectedDoctor(doctor);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedDoctor(null);
  };

  return (
    <div className="p-3 sm:p-6">

      {/* ───────── HEADER ───────── */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-5 shadow-sm">

        {/* Title */}
        <div>
          <h1 className="text-[15px] sm:text-[17px] font-[500] text-gray-800">
            Doctors Table
          </h1>
          <p className="text-[11px] sm:text-[12px] text-gray-400 mt-0.5">
            {filteredData?.length || 0} records found
          </p>
        </div>

        {/* Search + Button */}
        <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">

          {/* Search */}
          <div className="relative w-full sm:w-[230px]">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search by name..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[8px] w-full text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>

          {/* Button */}
          <Link to="AddEditDoctor" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-4 py-[8px] rounded-lg">
              + New Doctor
            </button>
          </Link>

        </div>
      </div>

      {/* ───────── DESKTOP TABLE ───────── */}
      <div className="hidden md:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">

        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px]">

            <thead>
              <tr className="bg-[#215187] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">Sr No.</th>
                <th className="py-3 px-4 text-left">Name</th>
                <th className="py-3 px-4 text-left">Specialization</th>
                <th className="py-3 px-4 text-left">Contact</th>
                <th className="py-3 px-4 text-center">CNIC</th>
                <th className="py-3 px-4 text-center">Qualification</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={7} className="py-10 text-center text-gray-400">
                    Loading...
                  </td>
                </tr>
              ) : paginatedData?.length === 0 ? (
                <tr>
                  <td colSpan={7} className="py-10 text-center text-gray-400">
                    No records found
                  </td>
                </tr>
              ) : (
                paginatedData?.map((patient) => (
                  <tr
                    key={patient?.id}
                    className="border-t hover:bg-gray-50 text-[13px]"
                  >
                    <td className="py-3 px-4">{patient?.id}</td>
                    <td className="py-3 px-4 font-[500]">{patient?.name}</td>
                    <td className="py-3 px-4">{patient?.specialization}</td>
                    <td className="py-3 px-4">{patient?.phone_no}</td>
                    <td className="py-3 px-4 text-center">{patient?.cnic}</td>
                    <td className="py-3 px-4 text-center">{patient?.qualification}</td>
                    <td className="py-3 px-4 text-center">
                      <button
                        onClick={() => handleViewClick(patient)}
                        className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>
        </div>
      </div>

      {/* ───────── MOBILE CARDS ───────── */}
      <div className="md:hidden flex flex-col gap-3">

        {loading ? (
          <div className="bg-white border rounded-xl py-10 text-center text-gray-400">
            Loading...
          </div>
        ) : paginatedData?.length === 0 ? (
          <div className="bg-white border rounded-xl py-10 text-center text-gray-400">
            No records found
          </div>
        ) : (
          paginatedData?.map((patient) => (
            <div
              key={patient?.id}
              className="bg-white border rounded-xl p-4 shadow-sm"
            >

              {/* Top */}
              <div className="flex justify-between items-start mb-3">
                <div>
                  <p className="font-semibold text-gray-800">
                    {patient?.name}
                  </p>
                  <p className="text-[11px] text-gray-400">
                    ID: {patient?.id}
                  </p>
                </div>

                <button
                  onClick={() => handleViewClick(patient)}
                  className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md"
                >
                  View
                </button>
              </div>

              {/* Details */}
              <div className="grid grid-cols-2 gap-2 text-[12px]">
                <p><span className="text-gray-400">Spec:</span> {patient?.specialization}</p>
                <p><span className="text-gray-400">Phone:</span> {patient?.phone_no}</p>
                <p><span className="text-gray-400">CNIC:</span> {patient?.cnic}</p>
                <p><span className="text-gray-400">Qual:</span> {patient?.qualification}</p>
              </div>

            </div>
          ))
        )}
      </div>

      {/* ───────── PAGINATION ───────── */}
      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={10}
      />

      {/* ───────── MODAL ───────── */}
      <DoctorDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        doctorDetails={selectedDoctor}
      />
    </div>
  );
};

export default Doctors;